/* TETSU theme — minimal vanilla JS (no dependencies) */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    /* --- Homepage / visual size chips (no variant context) --- */
    document.querySelectorAll('[data-size-group]').forEach(function (group) {
      var chips = group.querySelectorAll('[data-size]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
        });
      });
    });
  });
})();
